<template>
  <div>
    <base-nav
      v-model="showMenu"
      type="light"
      :transparent="true"
      menu-classes="justify-content-end"
      class="navbar-horizontal navbar-main"
      containerClasses="container-fluid"
      expand="lg"
    >
      <div slot="brand" class="navbar-wrapper">
        <b-navbar-brand to="/">
          <img src="assets/img/logo.png" />
        </b-navbar-brand>
      </div>

      <template>
        <div class="navbar-collapse-header">
          <b-row>
            <b-col cols="6" class="collapse-brand">
              <router-link to="/">
                <img src="img/brand/logo.png" />
              </router-link>
            </b-col>
            <b-col cols="6" class="collapse-close">
              <button
                type="button"
                class="navbar-toggler"
                @click="showMenu = false"
              >
                <span></span>
                <span></span>
              </button>
            </b-col>
          </b-row>
        </div>

        <b-navbar-nav class="mr-auto">
          <b-nav-item to="/features">
            <span class="nav-link-inner--text">Features</span>
          </b-nav-item>
          <b-nav-item to="/pricing">
            <span class="nav-link-inner--text">Pricing</span>
          </b-nav-item>
          <!-- <b-nav-item to="/login">
             <span class="nav-link-inner--text">Login</span>
         </b-nav-item> -->
          <b-nav-item to="/services">
            <span class="nav-link-inner--text">Services</span>
          </b-nav-item>
          <b-nav-item
            href="https://support.devopsintegration.io/support/solutions/82000195912"
            target="_blank"
          >
            <span class="nav-link-inner--text">Support</span>
          </b-nav-item>
          <b-nav-item-dropdown to="/apps" text="Resources">
            <b-dropdown-item to="/apps"
              >All Azure DevOps Integrations</b-dropdown-item
            >

            <b-dropdown-item to="/apps/zendesk-azure-devops-integration"
              >Zendesk - Azure DevOps</b-dropdown-item
            >
            <b-dropdown-item to="/apps/freshdesk-azure-devops-integration"
              >Freshdesk - Azure DevOps</b-dropdown-item
            >
            <b-dropdown-item to="/apps/freshservice-azure-devops-integration"
              >Freshservice - Azure DevOps</b-dropdown-item
            >
            
            <b-dropdown-item to="/apps/change-management-devops-integration"
              >Change Management - Azure DevOps</b-dropdown-item
            >

            <b-dropdown-item to="/apps/monday-azure-devops-integration"
              >monday - Azure DevOps</b-dropdown-item
            >

            <b-dropdown-item to="/apps/zendesk_azure_devops"
              >Azure DevOps + Zendesk Integrations</b-dropdown-item
            >
            <b-dropdown-item to="/apps/freshdesk_azure_devops"
              >Azure DevOps + Freshdesk Integrations</b-dropdown-item
            >
            <b-dropdown-item to="/apps/freshservice_azure_devops"
              >Azure DevOps + Freshservice Integrations</b-dropdown-item
            >
            <b-dropdown-item
              to="/it-service-management/change-management-devops-integration"
              >Azure DevOps + Change Management</b-dropdown-item
            >

            <b-dropdown-item to="/apps/monday_azure_devops"
              >Azure DevOps + monday Integrations</b-dropdown-item
            >
          </b-nav-item-dropdown>
          <b-nav-item-dropdown to="/installation" text="Installation">
            <b-dropdown-item
              href="/apps/support/azure-devops-integration/"
              target="_blank"
              >Zendesk - Azure DevOps</b-dropdown-item
            >
            <b-dropdown-item
              href="https://www.freshworks.com/apps/freshdesk_azure_devops_integration/"
              target="_blank"
              >Freshdesk - Azure DevOps</b-dropdown-item
            >
            <b-dropdown-item
              href="https://www.freshworks.com/apps/freshservice_azure_devops_integration/"
              target="_blank"
              >Freshservice - Azure DevOps</b-dropdown-item
            >

            <b-dropdown-item
              href="https://monday.com/marketplace/listing/10000746/azure-devops-integration-bisync"
              target="_blank"
              >monday - Azure DevOps</b-dropdown-item
            >
          </b-nav-item-dropdown>
          <b-nav-item to="/faq">
            <span class="nav-link-inner--text">FAQ</span>
          </b-nav-item>
          <b-nav-item
            link-classes="nav-link-icon"
            href="https://support.devopsintegration.io/support/solutions/82000195912"
            target="_blank"
            data-toggle="tooltip"
            title="Need Help?"
          >
            <span class="nav-link-inner--text">Docs</span>
          </b-nav-item>

          <!-- <b-nav-item link-classes="nav-link-icon" href="javascript:void(0);" title="Give us feedback" data-feedback-fish>
          <span class="nav-link-inner--text">Feedback</span>
        </b-nav-item> -->
        </b-navbar-nav>
        <hr class="d-lg-none" />
        <b-navbar-nav class="align-items-lg-center ml-lg-auto">
          <b-nav-item
            link-classes="nav-link-icon"
            href="mailto:support@devopsintegration.io"
            target="_blank"
            data-toggle="tooltip"
            title="Email Us at support@devopsintegration.io"
          >
            <i class="fa fa-envelope"></i>
            <span class="nav-link-inner--text d-lg-none">Email</span>
          </b-nav-item>
          <b-nav-item
            link-classes="nav-link-icon"
            href="https://support.devopsintegration.io/support/solutions/82000195912"
            target="_blank"
            data-toggle="tooltip"
            title="Need Help?"
          >
            <i class="fa fa-database"></i>
            <span class="nav-link-inner--text d-lg-none">Support</span>
          </b-nav-item>
          <!-- This item dont have <b-nav-item> because they add class 'nav-link' which is not needed here -->
          <li class="nav-item d-none d-lg-block ml-lg-4">
            <router-link
              to="/contact"
              class="btn btn-neutral text-primary btn-icon"
            >
              <span class="nav-link-inner--text">Need help</span>
              <span class="btn-inner--icon">
                <i class="fas fa-question mr-2"></i>
              </span>
            </router-link>
          </li>
        </b-navbar-nav>
      </template>
    </base-nav>

    <div class="main-content">
      <zoom-center-transition :duration="pageTransitionDuration" mode="out-in">
        <router-view></router-view>
      </zoom-center-transition>
    </div>

    <footer class="py-3" id="footer-main">
      <b-container fluid>
        <b-row align-v="center" class="justify-content-xl-between">
          <b-col xl="6">
            <div class="copyright text-center text-xl-left text-muted">
              © {{ year }}
              <a
                href="https://www.devopsintegration.io"
                class="font-weight-bold ml-1"
                target="_blank"
                >DevOps Integration</a
              >
            </div>
          </b-col>
          <b-col xl="6" class="col-xl-6">
            <b-nav
              class="nav-footer justify-content-center justify-content-xl-end"
            >
              <b-nav-item to="/terms">Legal</b-nav-item>
              <b-nav-item to="/privacy">Privacy</b-nav-item>
              <b-nav-item to="/contact">Contact Us</b-nav-item>
              <b-nav-item
                href="https://support.devopsintegration.io/support/solutions/82000195912"
                target="_blank"
              >
                Support
              </b-nav-item>
            </b-nav>
          </b-col>
        </b-row>
      </b-container>
    </footer>
  </div>
</template>
<script>
import { BaseNav } from "@/components";
import { ZoomCenterTransition } from "vue2-transitions";

export default {
  components: {
    BaseNav,
    ZoomCenterTransition
  },
  props: {
    backgroundColor: {
      type: String,
      default: "black"
    }
  },
  data() {
    return {
      showMenu: false,
      menuTransitionDuration: 250,
      pageTransitionDuration: 200,
      year: new Date().getFullYear(),
      pageClass: "login-page"
    };
  },
  computed: {
    title() {
      return `${this.$route.name} Page`;
    }
  },
  methods: {
    toggleNavbar() {
      document.body.classList.toggle("nav-open");
      this.showMenu = !this.showMenu;
    },
    closeMenu() {
      document.body.classList.remove("nav-open");
      this.showMenu = false;
    },
    setBackgroundColor() {
      document.body.classList.add("bg-default");
    },
    removeBackgroundColor() {
      document.body.classList.remove("bg-default");
    },
    updateBackground() {
      if (!this.$route.meta.noBodyBackground) {
        this.setBackgroundColor();
      } else {
        this.removeBackgroundColor();
      }
    }
  },
  beforeDestroy() {
    this.removeBackgroundColor();
  },
  beforeRouteUpdate(to, from, next) {
    // Close the mobile menu first then transition to next page
    if (this.showMenu) {
      this.closeMenu();
      setTimeout(() => {
        next();
      }, this.menuTransitionDuration);
    } else {
      next();
    }
  },
  watch: {
    $route: {
      immediate: true,
      handler: function() {
        this.updateBackground();
      }
    }
  }
};
</script>
<style lang="scss">
$scaleSize: 0.8;
@keyframes zoomIn8 {
  from {
    opacity: 0;
    transform: scale3d($scaleSize, $scaleSize, $scaleSize);
  }
  100% {
    opacity: 1;
  }
}

.main-content .zoomIn {
  animation-name: zoomIn8;
}

@keyframes zoomOut8 {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
    transform: scale3d($scaleSize, $scaleSize, $scaleSize);
  }
}

.main-content .zoomOut {
  animation-name: zoomOut8;
}
</style>
